import { PageResponse } from './../models/page-response';
import { environment } from '@env/environment';
import { AdminUser } from './../models/admin-user';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { UserSearchingCriteria } from '@models/user';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CommonService } from './common.service';
import { CommonResponse } from '@app/models/common-model';


@Injectable()
export class AdminUserService {

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService
    ) { }

    globalSearch(globalCriteria: string = '', criteria: UserSearchingCriteria, page: number = 0, size: number = 10, sortField: string, sortDirection: string = 'asc'): Observable<PageResponse<AdminUser>> {

        let params: HttpParams = new HttpParams();
        params = params.set('global', globalCriteria);
        params = params.set('criteria', JSON.stringify(criteria == null ? new UserSearchingCriteria() : criteria));
        params = params.set('page', page.toString());
        params = params.set('size', size.toString());
        if (sortField != null) {
            params = params.set('sort', sortField + ',' + sortDirection);
        }

        return this.httpClient.get(`${environment.API_END_POINT}/adminUsers`, { headers: this.commonService.getHeaders(), params: params })
            .pipe(
                map(response => {
                    let tempObj = <PageResponse<AdminUser>>response;

                    tempObj.content.forEach(x => {
                        delete x.authorities;
                        if (x.supervisor != null) {
                            delete x.supervisor.authorities;
                        }
                    })

                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    insert(user: AdminUser): Observable<AdminUser> {

        let body = JSON.stringify(user);

        return this.httpClient.post(`${environment.API_END_POINT}/user/create`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => {
                    let tempObj = <AdminUser>((<any>response).content);
                    delete tempObj.authorities;
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

     get(id: string): Observable<AdminUser> {
        return this.httpClient.get(`${environment.API_END_POINT}/user/${id}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => {
                    let tempObj = <AdminUser>((<any>response).content);
                    delete tempObj.authorities;

                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    checkUniqueSettings(userId: string,userName: string, email: string): Observable<CommonResponse> {
        return this.httpClient.get(`${environment.API_END_POINT}/user/checkemail/${userId}/${email}/${userName}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => { 
                    return response;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    update(user: AdminUser): Observable<AdminUser> {

        let body = JSON.stringify(user);

        return this.httpClient.put(`${environment.API_END_POINT}/user/update/${user.userId}`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => {
                    let tempObj = <AdminUser>((<any>response).content);
                    delete tempObj.authorities;

                    if (tempObj.supervisor != null) {
                        delete tempObj.supervisor.authorities;
                    }

                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    findAll(): Observable<AdminUser[]> {


        return this.httpClient.get(`${environment.API_END_POINT}/adminUsers/all`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => {
                    let tempObj = <AdminUser[]>((<any>response).content);
                    if(tempObj && tempObj.length > 0){

                        tempObj.forEach(tem =>{
                            delete tem.authorities;
                            if (tem.supervisor != null) {
                                delete tem.supervisor.authorities;
                            }
                        })
                    }

                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }



}